<template lang="pug">
  div
    h2(class="new-advert-subtitle mb-4") Адрес
    v-col(cols="12" class="pa-0")
      v-row(justify="space-between")
        v-col(cols="6" class="py-0")
          v-select(
          label="Територрия",
          v-model.number="cityId"
          :items="cityList"
          item-text="text"
          item-value="id"
          outlined
          dense)
        v-col(cols="6" class="py-0")
          v-select(
            label="Районы",
            v-model="districtId"
            :items="districtList"
            item-text="text"
            item-value="id"
            outlined
            dense)
      v-text-field(
        v-model="address",
        label="Адрес"
        placeholder="Укажите адрес"
        outlined
        dense)
      v-row(no-gutters)
        Map(:points="centerCoordinates")
</template>

<docs>
  ```html
  <Address
    @set-city-id="setCityId"
    @set-district-id="setDistrictId"
    @set-address="setAddress"
  />
  ```
</docs>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Address',
  components: {
    Map: () => import('@/components/Adverts/AddNew/Map.vue')
  },
  data: () => ({
    cityId: 1,
    districtId: null,
    address: ''
  }),
  created() {
    /**
     * запрос с сервера списка городов.
     */
    this.$store.dispatch('GET_CITY_LIST')
  },
  watch: {
    cityId: {
      immediate: true,
      handler(value) {
        if (this.cityList.length) {
          const result = this.cityList.filter(item => item.id === value)[0]
          if (result.data) {
            this.$store.commit('SET_COORDINATION', JSON.parse(result.data))
          }
        }
        this.$store.dispatch('GET_DISTRICT_LIST', value)
        /**
         * Срабатывает при выборе города из списка городов
         *
         * @property {string} value - идентификатор выбранного города
         */
        this.$emit('set-city-id', value)
      }
    },
    districtId(id) {
      /**
       * Срабатывает при выборе района из списка районов
       *
       * @property {string} id - идентификатор выбранного района
       */
      this.$emit('set-district-id', id)
    },
    address(value) {
      /**
       * Срабатывает при изменении значения в тектовом поле для ввода адреса
       *
       * @property {string} value - значение из поля для ввода адреса
       */
      this.$emit('set-address', value)
    }
  },
  computed: {
    ...mapState({
      cityList: state => state.cityList,
      districtList: state => state.districtList,
      centerCoordinates: state => state.coordinates
    })
  }
}
</script>
